export default "__VITE_ASSET__231c41cc__"